module.exports = __webpack_public_path__ + "static/media/quotation-mark.5892655a.png";